// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__u21Ij","col":"styles_col__1QByE"};